import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import "moment/locale/fr";
import { Form } from "react-formio";
import semantic from "@formio/semantic";
import { Formio } from "formiojs";
import premium from "@formio/premium";
import "@formio/premium/dist/premium.css";
Formio.use(premium);
Formio.use(semantic);
Formio.Templates.framework = "semantic";
const VisitPreviewFormio = props => {
  const [form, setForm] = useState(null);
  const [submission, setSubmission] = useState(null);
  useEffect(() => {
    const currentVisit = props.currentVisit || {};
    const formio_url = currentVisit.source_url;
    const formio = new Formio(formio_url);
    formio.loadForm().then(function(f) {
      f.display = 'form';
      setForm(f);
    });

    const visitSurveys = currentVisit.survey || [];
    const visitSurvey = visitSurveys[0] || {};
    const visitData = visitSurvey.data || null;
    setSubmission({ data: visitData });
  }, []);

  if (!props.currentVisit) return null;

  return (
    <div className="preview-formio">
      {!form && <div>Chargement ...</div>}
      {form && (
        <Form
          form={form}
          url={props.currentVisit && props.currentVisit.source_url}
          submission={submission}
          options={{
            buttonSettings: {
              showCancel: false,
              showSubmit: false
            },
            readOnly: true
          }}
        />
      )}
    </div>
  );
};

export default withRouter(VisitPreviewFormio);



// WEBPACK FOOTER //
// src/components/visit/PreviewFormio.js